import {
  installChunkLoadReload,
  lazyWithRetry,
} from '@viva-finance/viva-components';
import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';

import Fallback from 'src/components/Fallback';
import '@viva-finance/viva-components/dist/tailwind.css';
import '@viva-finance/viva-components/dist/public/index.css';
import '@viva-finance/viva-components/dist/viva-components.css';

installChunkLoadReload({ disabled: import.meta.env.DEV });

const App = lazyWithRetry(() => import('src/App'));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Suspense fallback={<Fallback />}>
    <App />
  </Suspense>
);
